module.exports = __webpack_public_path__ + "img/result.60180535.png";